import request from "@/utils/request.js";

/**
 * 医院护士信息-同步到护士加（v3.0）
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserInfo(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/getUserInfo",
    method: "post",
    data: params
  });
}

/**
 * 修改医院护士信息-同步到护士加（v3.0）
 * @param params
 * @returns {AxiosPromise}
 */
export function modifyUserInfo(params) {
  return request({
    url: "/teachingPlatformService/api/app/orgUser/modifyUserInfo",
    method: "post",
    data: params
  });
}
